const platform =
  typeof navigator === 'undefined'
    ? ''
    : ((navigator as Navigator & { userAgentData?: { platform: string } }).userAgentData
        ?.platform ?? navigator.platform);

export const IS_MAC = /Mac|iPod|iPhone|iPad/.test(platform);
export const MOD_KEY = IS_MAC ? '⌘' : 'Ctrl';

const MOD_SYMBOLS: Record<string, string> = IS_MAC
  ? { mod: '⌘', shift: '⇧', alt: '⌥', ctrl: '⌃', meta: '⌘' }
  : { mod: 'Ctrl+', shift: 'Shift+', alt: 'Alt+', ctrl: 'Ctrl+', meta: 'Meta+' };

export function formatShortcut(spec: string): string {
  const parts = spec.toLowerCase().split('+');
  const prefixes: string[] = [];
  let key = '';
  for (const part of parts) {
    const mod = MOD_SYMBOLS[part];
    if (mod) {
      prefixes.push(mod);
    } else {
      key = part.toUpperCase();
    }
  }
  return prefixes.join('') + key;
}
